<template>
  <div class="project">
    <project-header :project="project"></project-header>

    <div class="project-gallery row">
      <div class="col-12 ta-center">
        <video class="project-gallery__fullsize-video project-gallery__video--medium" playsinline muted loop>
          <source src="/static/videos/een/een-logo-gif.mp4">
        </video>
      </div>
      <div class="col-12 ta-center een__logo-gif">
        <video class="project-gallery__fullsize-video project-gallery__video--medium" playsinline muted loop>
          <source src="/static/videos/een/een-logo-gif-2.mp4">
        </video>
      </div>
    </div>
    <div class="col-12 project-gallery__img" v-for="image in firstSection" :key="image">
      <img class="project-gallery__image" :src="`/static/images/een/${image}`">
    </div>
    <project-footer prev="/work/get-clean" next="/work/by-wood"></project-footer>
  </div>
</template>

<script>
import project from '../../mixins/project'
import automaticallyPlayVideo from '../../mixins/automaticallyPlayVideo'
import projects from '../../projects'

export default {
  name: 'clean-sound',
  data () {
    return {
      project: projects.find(project => project.title === 'Een'),
      firstSection: [
        'een-logo-1.jpg',
        'een-poster-1.jpg',
        'een-poster-2.jpg',
        'een-poster-3.jpg',
        'een-poster-outdoor-1.jpg',
        'een-stationery-1.jpg',
        'een-stationery-2.jpg '
      ]
    }
  },
  mixins: [
    project,
    automaticallyPlayVideo
  ]
}
</script>

<style lang="sass" scoped>

@import "../../assets/sass/utilities/variables"
@import "../../assets/sass/utilities/mixins"

.project-gallery__fullsize-video
  margin-bottom: 40px
  height: auto !important
  max-width: 500px
  +medium
    margin-bottom: 75px

.een__logo-gif
  margin-bottom: 50px

</style>



// WEBPACK FOOTER //
// Een.vue?57211b52